<template>
    <!-- 总览-每日新增受邀用户数-->
    <div class="v4-chart-box">
      <!-- 图表加载中 -->
      <v-loading-chart :loading="loading" width="100%" height="400px">
      </v-loading-chart>
      <!--  图表加载失败 -->
      <v-loading-chart-err
        :loadingErr="loadingErr"
        width="100%"
        height="400px"
        @onErrReset="onErrReset"
      >
      </v-loading-chart-err>
      <div
        v-if="!loading"
        id="myCharts7"
        ref="myCharts7"
        style="width: 100%; height: 400px"
      ></div>
    </div>
  </template>
  <script>
  export default {
    props: ["chartData", "loading", "loadingErr"],
    data() {
      return {
        xAxisData: [], //x轴
        seriesData: [1, 100, 200, 0, 400], //y轴
      };
    },
    watch: {
      chartData(v) {
        if (v) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.initChart();
            }, 300);
          });
        }
      },
    },
    methods: {
      // 初始化图表
      initChart() {
        this.xAxisData = [];
        this.seriesData = [];
        this.chartData.forEach((item) => {
          this.xAxisData.push(item.timestamp);
          this.seriesData.push(item.amount); //资产总额
        });
        let myChart = this.$echarts.init(document.getElementById("myCharts7"));
        const chartColors = this.$getChartColors();
        let option = {
          color: chartColors,
          title: {
            //   text: "交易量",
          },
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(0,0,0,0.649)",
            borderWidth: "1", //边框宽度设置1
            borderColor: "#F2F4FB", //设置边框颜色
            textStyle: {
              color: "#fff", //设置文字颜色
              fontFamily: "HarmonyOS-Regular",
            },
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
            formatter: (params) => {
              var relVal = params[0].name;
              for (var i = 0, l = params.length; i < l; i++) {
                relVal +=
                  "<br/>" +
                  params[i].marker +
                  params[i].seriesName +
                  "&nbsp;&nbsp;" +
                  params[i].value
                  // "&nbsp;" +
                  // this.chartData[0].marginCoin;
              }
              return relVal;
            },
          },
          legend: {
            data: [""],
          },
          toolbox: {
            //   feature: {
            //     saveAsImage: {},
            //   },
          },
          grid: {
            // left: "0%",
            // right: "0%",
            // bottom: "0%",
            left: "0%",
            right: "3.5%",
            bottom: "12%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              axisLine: {
                //x轴线颜色
                show: true,
                lineStyle: {
                  color: "#F2F4FB",
                  width: 1,
                  type: "solid",
                },
              },
              axisLabel: {
                //x轴文字的配置
                show: true,
                textStyle: {
                  color: "#93979D",
                  fontFamily: "HarmonyOS-Medium",
                },
                // rotate: -80,
              },
              // name: " 年 ",
              data: this.xAxisData,
              axisTick: {
                alignWithLabel: true,
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              axisLabel: {
                //x轴文字的配置
                show: true,
                textStyle: {
                  color: "#93979D",
                  fontFamily: "HarmonyOS-Medium",
                },
              },
            },
          ],
          dataZoom: [
            {
              type: "slider", //滑动条
              show: true, //开启
              xAxisIndex: [0],
              start: 1, //初始化时，滑动条宽度开始标度
              end: 100, //初始化时，滑动条宽度结束标度
            }, //X轴内置滑动
          ],
          series: [
            {
              name: this.$t("lanV4.overInvitedUsers"), //每日新增直属下级
              type: "line",
              stack: "总量",
              areaStyle: {
                normal: {
                  opacity: 0.4,
                  // color: "#d6e3fd", //改变区域颜色
                  color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                    color: chartColors[0],
                    },
  
                    {
                      offset: 1,
                      color: "#ffffff",
                    },
                  ]),
                },
              },
              emphasis: {
                focus: "series",
              },
              data: this.seriesData,
              smooth: true,
              itemStyle: {
                normal: {
                color: chartColors[0], //改变折线点的颜色
                  lineStyle: {
                  color: chartColors[0],
                  },
                },
              },
            },
          ],
        };
        myChart.setOption(option);
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      },
      // 失败重试
      onErrReset() {
        this.$emit("onErrReset");
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .v4-chart-box {
    position: relative;
    width: 100%;
    height: 415px;
  }
  </style>
